const PERCENT_KEYS = new Set([
  'returnOnEquityTTM',
  'grossProfitMarginTTM',
  'netProfitMarginTTM',
  'debtRatioTTM',
  'revenue_cagr',
  'revenue_1yr_growth',
  'revenue_3yr_growth',
  'grossProfit_1yr_growth',
  'grossProfit_3yr_growth',
  'forecast_next_year_revenue_growth_rate',
  'forecast_next_year_profit_growth_rate',
  'eps_cagr',
  'pcnt_upside_in_range_6m',
  'pcnt_from_sma200',
]);

const CURRENCY_KEYS = new Set(['dcf']);

const toNumber = (val) => (typeof val === 'string' ? Number(val) : val);

export const formatChartDetailValue = (key, val) => {
  if (val === undefined || val === null || val === '') return 'N/A';
  const num = toNumber(val);
  const isNum = typeof num === 'number' && !Number.isNaN(num);

  if (key === 'is_etf') {
    return (val === true || val === 1 || val === '1' || String(val).toLowerCase() === 'true') ? 'True' : 'False';
  }
  if (key === 'piotroskiScore' && isNum) return String(Math.round(num));
  if (key === 'rule_of_40' && isNum) return String(Math.round(num * 100));
  if (CURRENCY_KEYS.has(key) && isNum) return `$${num.toFixed(2)}`;
  if (key === 'pcnt_from_sma200' && isNum) {
    if (num > 0) return `${Math.round(num * 100)}% above`;
    if (num < 0) return `${Math.round(Math.abs(num) * 100)}% below`;
    return '0%';
  }
  if (key === 'price_to_dcf_ratio' && isNum && num < 0) return '0';
  if (PERCENT_KEYS.has(key) && isNum) return `${Math.round(num * 100)}%`;
  if (isNum) return num.toFixed(2);
  return String(val);
};

export const pegRatioColorClass = (val) => {
  const num = toNumber(val);
  if (typeof num !== 'number' || Number.isNaN(num)) return '';
  if (num < 0) return 'text-red-600';
  if (num <= 1) return 'text-green-600';
  if (num > 2) return 'text-red-600';
  return '';
};

export const dcfValuationColorClass = (val) => {
  const num = toNumber(val);
  if (typeof num !== 'number' || Number.isNaN(num)) return '';
  return num < 0 ? 'text-red-600' : '';
};

export const priceToDcfRatioColorClass = (val) => {
  const num = toNumber(val);
  if (typeof num !== 'number' || Number.isNaN(num)) return '';
  if (num > 0 && num < 1) return 'text-green-600';
  if (num >= 1) return 'text-black';
  return '';
};
